module.exports = __webpack_public_path__ + "img/icon-search.abb3dce5.svg";